import { useGLTF } from "@react-three/drei";
import { ThreeEvent } from "@react-three/fiber";
import { useEffect } from "react";

interface ModelProps {
  url: string;
  onMeshClick?: (event: ThreeEvent<MouseEvent>) => void;
  onPointerMove?: (event: ThreeEvent<PointerEvent>) => void;
  onPointerDown?: (event: ThreeEvent<PointerEvent>) => void;
  onPointerUp?: () => void;
  onPointerLeave?: () => void;
  cursorStyle?: string;
}

export const Model = ({ 
  url, 
  onMeshClick, 
  onPointerMove, 
  onPointerDown, 
  onPointerUp,
  onPointerLeave,
  cursorStyle = 'default'
}: ModelProps) => {
  const { scene } = useGLTF(url);
  
  // 设置鼠标样式
  useEffect(() => {
    const canvas = document.querySelector('canvas');
    if (canvas) {
      canvas.style.cursor = cursorStyle;
    }
    
    // 清理函数：组件卸载时重置为默认样式
    return () => {
      const canvas = document.querySelector('canvas');
      if (canvas && cursorStyle !== 'default') {
        canvas.style.cursor = 'default';
      }
    };
  }, [cursorStyle]);
  
  return (
    <primitive 
      object={scene} 
      onClick={onMeshClick}
      onPointerMove={onPointerMove}
      onPointerDown={onPointerDown}
      onPointerUp={onPointerUp}
      onPointerLeave={onPointerLeave}
    />
  );
};

Model.displayName = "Model";
